import React, { useContext } from "react";

import NeedHelp from "../need-help";

import { scrollError } from '../../helpers'
import MembershipFormContext from '../../context/membership'

interface PrevNextProps {
  [key: string]: any
}

const PrevNext: React.FC<PrevNextProps> = (props: any) => {

  const membershipForm = useContext(MembershipFormContext)

  return (
    <>
      <div className="row">
        <div className="prev-next clearfix box">
          <div className="medium-6 columns">
            <button type="submit" className="btn-cta go" id="m-next-button-2" onClick={() => {scrollError()}}>Next</button>
            { !membershipForm.preSelectedMembership &&
              <button type="button" className="btn-cta back" id="m-back-button-2" onClick={() => props.navigate(-1)}>Back</button>
            }
          </div>
          <div className="medium-6 columns">
            <div className="nobox">
              <NeedHelp />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrevNext;